@if (currentProject) {
  <div>
    <ix-content-header
      slot="header"
      hasBackButton="true"
      [headerTitle]="currentProject.name"
      (click)="backButtonClick()"
    >
    </ix-content-header>
    <div class="page-content">
      <ix-workflow-steps
        [selectedIndex]="stateMaschine.currentState"
        [clickable]="getFormGroup(stateMaschine.currentState).valid"
      >
        <ix-workflow-step status="open" (click)="selectWorkflowStep(State.Step1)">Basics</ix-workflow-step>
        <ix-workflow-step [hidden]="isSimpleCalculation" status="open" (click)="selectWorkflowStep(State.Step2)"
          >Assets Inventory</ix-workflow-step
        >
        <ix-workflow-step [hidden]="isSimpleCalculation" status="open" (click)="selectWorkflowStep(State.Step3)"
          >Services</ix-workflow-step
        >
        <ix-workflow-step status="open" (click)="selectWorkflowStep(State.Step4)">Pricing</ix-workflow-step>
        <ix-workflow-step status="open" (click)="selectWorkflowStep(State.Step5)">Results</ix-workflow-step>
      </ix-workflow-steps>
      @if (stateMaschine.currentState === State.Step1) {
        <div class="container">
          <app-basic-info
            [basisInfoForm]="basisInfoForm"
            [projectId]="projectId"
            (onStepForward)="nextStep()"
            (simpleCalculation)="changeSimpleCalculation($event)"
          ></app-basic-info>
        </div>
      } @else if (stateMaschine.currentState === State.Step2) {
        <div class="container">
          <app-equipment-inventory
            [equipmentInventoryForm]="equipmentInventoryForm"
            [projectId]="projectId"
            (onStepForward)="nextStep()"
            (onStepBackward)="stepBack()"
          ></app-equipment-inventory>
        </div>
      } @else if (stateMaschine.currentState === State.Step3) {
        <div class="container">
          <app-services
            [servicesForm]="servicesForm"
            [projectId]="projectId"
            (onStepForward)="nextStep()"
            (onStepBackward)="stepBack()"
          ></app-services>
        </div>
      } @else if (stateMaschine.currentState === State.Step4) {
        <div class="container">
          <app-pricing
            [pricingForm]="pricingForm"
            [projectId]="projectId"
            (onStepForward)="nextStep()"
            (onStepBackward)="stepBack()"
          ></app-pricing>
        </div>
      } @else if (stateMaschine.currentState === State.Step5) {
        <div class="container">
          <app-contract
            [contractForm]="contractForm"
            [projectId]="projectId"
            (onStepBackward)="stepBack()"
          ></app-contract>
        </div>
      }
    </div>
  </div>
}
